import { CustomerDetailsComponent } from "./customer-details.component";
import { RouterModule, Routes } from "@angular/router";
import { EmployeeIdSelectionComponent } from "../../../core/shared/employee-selection/employee-id-selection.component";

const routes: Routes = [
    { path: ':Id', component: CustomerDetailsComponent },
    { path: 'new', component: CustomerDetailsComponent },
    { path: 'selectUser', loadChildren: () => EmployeeIdSelectionComponent }
];

export const CustomerDetailsRouting = RouterModule.forChild(routes);